import React from 'react';

import Button from 'material-ui/Button';
import Switch from 'material-ui/Switch';
import IconButton from 'material-ui/IconButton';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import Menu, { MenuItem } from 'material-ui/Menu';
import { ListItemIcon, ListItemText } from 'material-ui/List';
import Tooltip from 'material-ui/Tooltip';

import MoreIcon from '@material-ui/icons/MoreHoriz';
import DeleteIcon from '@material-ui/icons/Delete';
import FlashIcon from '@material-ui/icons/FlashOn';
import MessageIcon from '@material-ui/icons/Message';
import SaveIcon from '@material-ui/icons/Save';

import Divider from 'material-ui/Divider';

import BlockTypeIcon from '../../../common/BlockTypeIcon';
import TrophyIcon from '../../../../lib/icons/TrophyIcon';
import { isCustomBlockTitle } from '../../../../lib/designerUtils';
import * as BlockUtils from '../../../../lib/blockUtils';
import { blockCategories } from '../../../../lib/paramTypes';

import Editable from '../Editable';
import BlockMenuLeaderboard from './BlockMenuLeaderboard';
import SupersetInstructions from './SupersetInstructions';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../../lib/segment/SegmentService';
import Console from '../../../../lib/debug';

const ACTIONS = {
    test: 'TEST',
    note: 'NOTE',
    repeat: 'REPEAT',
    delete: 'DELETE',
    save: 'SAVE'
};

export default class BlockHeader extends React.Component {
    state = {
        toggle: BlockUtils.hasLeaderboard(this.props.block),
        anchorEl: null,
        moreOptionsEl: null,
        isSupersetInstructionsOpen: !!this.props.block.instruction
    };

    componentWillReceiveProps(nextProps) {
        const isSupersetInstructionsOpen = !!nextProps.block.instruction;
        const toggle = BlockUtils.hasLeaderboard(nextProps.block);
        this.setState({ toggle, isSupersetInstructionsOpen });
    }

    editBlock(ev, action) {
        switch (action) {
            case ACTIONS.test:
                this.props.onToggleTest();
                break;
            case ACTIONS.delete:
                this.props.onDelete();
                break;
            case ACTIONS.note:
                this.onToggleNotes();
                break;
            case ACTIONS.save:
                this.props.onBlockSave();
                break;
            default:
                break;
        }
        this.setState(() => ({
            blockOptions: !this.state.blockOptions,
            moreOptionsEl: null
        }));
    }
    getBlockTitle() {
        let block = this.props.block;
        let isCustomTitle = isCustomBlockTitle(block.title);
        let isCustomCircuit =
            !block.workout_combo_id && parseInt(block.plain_text) === 1;
        let title = null;
        if (isCustomTitle && !isCustomCircuit) {
            title = block.title;
        } else {
            title = blockCategories[block.type].title;
        }
        return title;
    }

    handleClose = () => {
        this.setState({ anchorEl: null, moreOptionsEl: null });
    };

    handleMenuItemClick = (ev, value) => {
        this.setState({ anchorEl: null });
        this.props.onUpdateType(ev, value);

        SegmentService.track(SEGMENT_EVENTS['ClickCTA'].key, {
            sources: 'Web app',
            ctaLocation: 'Session builder',
            ctaText: 'Change Block Category'
        });
    };

    onToggle(e) {
        this.props.onToggle(e, this.toggle ? 0 : 1);
        this.toggle = !this.toggle;
        this.setState(() => ({
            toggle: !this.state.toggle
        }));
    }
    onUpdateTitle(title) {
        this.props.onUpdateTitle(title);
    }

    openEditMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    openOptionsMenu = event => {
        this.setState({ moreOptionsEl: event.currentTarget });
    };

    onToggleNotes = () => {
        const isOpen = !this.state.isSupersetInstructionsOpen;
        this.setState({ isSupersetInstructionsOpen: isOpen });
    };

    supersetInstructionsField = () => {
        if (!BlockUtils.isSuperset(this.props.block)) {
            return null;
        }
        if (!this.state.isSupersetInstructionsOpen) {
            return null;
        }
        return (
            <div
                className="block-notes-wrapper"
                ref={el => (this.$blockNotes = el)}
            >
                <SupersetInstructions
                    dispatch={this.props.dispatch}
                    block={this.props.block}
                />
            </div>
        );
    };

    render() {
        Console.render('designer.BlockHeader');

        const { block } = this.props;
        const { anchorEl, moreOptionsEl } = this.state;

        let typeToggle = null;
        let leaderboard = null;
        let testMenuItem = null;
        let testToggle = null;
        let supersetInstructions = null;
        let saveSuperset = null;
        let testToggleClasses = 'options layout-column';
        let titleEditorClasses = `block-title-editor bte-type-${block.type}`;
        let blockTitle = this.getBlockTitle();
        let tooltipTitle =
            block.plain_text === 1 && !block.workout_combo_id
                ? ''
                : 'Change Block Title';

        let blockTitleEditor = (
            <Tooltip title={tooltipTitle}>
                <div className={titleEditorClasses}>
                    <Editable
                        preventEdit={
                            block.plain_text === 1 && !block.workout_combo_id
                        }
                        value={blockTitle}
                        onValueChanged={this.onUpdateTitle.bind(this)}
                    />
                </div>
            </Tooltip>
        );
        let menuItems = blockCategories.map(category => (
            <MenuItem
                key={category.id}
                onClick={event => this.handleMenuItemClick(event, category.id)}
            >
                <ListItemIcon>
                    <BlockTypeIcon type={category.id} />
                </ListItemIcon>
                <ListItemText inset primary={category.title} />
            </MenuItem>
        ));

        typeToggle = (
            <Tooltip title="Change Block Category" placement="top">
                <div className="type-toggle">
                    <Button onClick={ev => this.openEditMenu(ev)}>
                        <BlockTypeIcon type={block.type} />
                        <KeyboardArrowDown />
                    </Button>
                    <Menu
                        className="th-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={this.handleClose}
                    >
                        {menuItems}
                    </Menu>
                </div>
            </Tooltip>
        );
        if (block.plain_text !== 1) {
            // Exercises Block Type
            leaderboard = <BlockMenuLeaderboard block={block} />;
        }
        if (BlockUtils.isSuperset(this.props.block)) {
            // Superset Block Type

            supersetInstructions = (
                <MenuItem
                    onClick={ev => this.editBlock(ev, ACTIONS.note)}
                    className={block.resets_working_max ? 'tested' : ''}
                >
                    <ListItemIcon>
                        <MessageIcon />
                    </ListItemIcon>
                    <ListItemText
                        inset
                        primary={
                            this.state.isSupersetInstructionsOpen
                                ? 'Hide Superset Instructions'
                                : 'Add Superset Instructions'
                        }
                    />
                </MenuItem>
            );

            saveSuperset = (
                <MenuItem
                    onClick={ev => this.editBlock(ev, ACTIONS.save)}
                    className={block.resets_working_max ? 'tested' : ''}
                >
                    <ListItemIcon>
                        <SaveIcon />
                    </ListItemIcon>
                    <ListItemText inset primary="Save Superset" />
                </MenuItem>
            );
        }
        if (block.plain_text === 1) {
            // Circuits Block Type
            if (BlockUtils.hasLeaderboard(block)) {
                this.toggle = true;
                leaderboard = (
                    <div className="circuit-toggle">
                        <TrophyIcon
                            className="trophy-icon"
                            onClick={this.onToggle.bind(this)}
                        />
                        <Switch
                            value="toggle"
                            checked={this.state.toggle}
                            onChange={this.onToggle.bind(this)}
                            color="primary"
                        />
                    </div>
                );
            }
        }
        testMenuItem = (
            <MenuItem
                onClick={ev => this.editBlock(ev, ACTIONS.test)}
                className={block.resets_working_max ? 'tested' : ''}
            >
                <ListItemIcon>
                    <FlashIcon />
                </ListItemIcon>
                <ListItemText
                    inset
                    primary={
                        !block.resets_working_max
                            ? 'Test This Block'
                            : 'Untest This Block'
                    }
                />
            </MenuItem>
        );

        if (block.resets_working_max) {
            testToggle = (
                <div className="ex-tested">
                    <i className="mdi mdi-flash icon" />
                    <span className="label">Test</span>
                    <i
                        className="untest"
                        onClick={this.props.onToggleTest.bind(this)}
                    >
                        &times;
                    </i>
                </div>
            );
        }

        let options = (
            <div className="edit-block">
                <IconButton onClick={ev => this.openOptionsMenu(ev)}>
                    <MoreIcon style={{ marginBottom: 4 }} />
                </IconButton>
                <Menu
                    className="th-menu"
                    open={Boolean(moreOptionsEl)}
                    anchorEl={moreOptionsEl}
                    onClose={this.handleClose}
                >
                    {testMenuItem}
                    {supersetInstructions}
                    {saveSuperset}
                    <Divider key="d1" />
                    <MenuItem
                        onClick={ev => this.editBlock(ev, ACTIONS.delete)}
                    >
                        <ListItemIcon>
                            <DeleteIcon />
                        </ListItemIcon>
                        <ListItemText inset primary="Delete" />
                    </MenuItem>
                </Menu>
            </div>
        );

        return (
            <div className="block-header layout-column">
                <div className="block-header-options">
                    <div className="block-type">
                        <div className={testToggleClasses}>
                            {typeToggle}
                            {blockTitleEditor}
                        </div>
                        <div className={`${testToggleClasses} right`}>
                            {leaderboard}
                            {testToggle}
                            {options}
                            {/*deleteBlockOpt*/}
                        </div>
                        {/*blockExport*/}
                    </div>
                </div>
                {this.supersetInstructionsField()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/designer/components/Block/BlockHeader.jsx